import { render, staticRenderFns } from "./PaymentSuccessed.vue?vue&type=template&id=1028de15"
import script from "./PaymentSuccessed.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports